import { useState } from "react";
import PersonalInformationDynamic from "./PersonalInformationDynamic";

export const SideMenuPersonalInformation = ({
  selectedMenu,
  setSelectedMenu,
  capturedImage,
  setCapturedImage,
  jsonObjForRenderingUi,
  setSegmentOrder,
  onClickToNextPage,
  validateForm,
  requiredFieldsWithPattern,
  order,
  onClickToPreviousPage,
}: any) => {
  const [capturedFileImage, setCapturedFileImage] = useState<File | undefined>(
    undefined
  );
  const [errors, setErrors] = useState<Record<string, string>>({});

  return (
    <PersonalInformationDynamic
      selectedMenu={selectedMenu}
      setSelectedMenu={setSelectedMenu}
      setSegmentOrder={setSegmentOrder}
      jsonobj={jsonObjForRenderingUi}
      capturedImage={capturedImage}
      capturedFileImage={capturedFileImage}
      setCapturedFileImage={setCapturedFileImage}
      setCapturedImage={setCapturedImage}
      order={order}
      onClickToNextPage={onClickToNextPage}
      validateForm={validateForm}
      requiredFieldsWithPattern={requiredFieldsWithPattern}
      onClickToPreviousPage={onClickToPreviousPage}
      errors={errors}
      setErrors={setErrors}
    />
  );
};
